import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

// Zoom caméra numérique RÉEL (Picamera2 ScalerCrop, dynamique sans coupure). 1x → 10x.
// Pas progressif : +0.5x jusqu'à 3x, +1x au-delà.
export const zoomStep = (z, dir) => {
  if (dir === "in") return z < 3 ? Math.min(3, +(z + 0.5).toFixed(1)) : Math.min(10, Math.round(z + 1));
  return z <= 3 ? Math.max(1, +(z - 0.5).toFixed(1)) : Math.max(3, Math.round(z - 1));
};

export function useCameraZoom(droneId, { enabled = true } = {}) {
  const [level, setLevel] = useState(1);
  const [applying, setApplying] = useState(false);
  const [error, setError] = useState(null);
  const [available, setAvailable] = useState(true);

  const load = useCallback(async () => {
    if (!droneId) return;
    try {
      const { data } = await api.get(`/drones/${droneId}/camera/zoom`);
      setLevel(data.level || 1); setAvailable(true);
    } catch { setAvailable(false); }
  }, [droneId]);

  const setZoom = useCallback(async (target) => {
    const t = Math.max(1, Math.min(10, target));
    setApplying(true); setError(null); setLevel(t);
    try {
      const { data } = await api.post(`/drones/${droneId}/camera/zoom`, { level: t });
      if (data.level) setLevel(data.level);
      setAvailable(true);
    } catch (e) { setError(e?.response?.data?.detail || "Zoom caméra indisponible"); }
    finally { setApplying(false); }
  }, [droneId]);

  const reset = useCallback(async () => {
    setApplying(true); setError(null); setLevel(1);
    try { await api.post(`/drones/${droneId}/camera/zoom/reset`); }
    catch (e) { setError(e?.response?.data?.detail || "Zoom caméra indisponible"); }
    finally { setApplying(false); }
  }, [droneId]);

  const zoomIn = useCallback(() => setZoom(zoomStep(level, "in")), [level, setZoom]);
  const zoomOut = useCallback(() => setZoom(zoomStep(level, "out")), [level, setZoom]);

  useEffect(() => { if (enabled) load(); }, [enabled, load]);

  return { level, applying, error, available, zoomIn, zoomOut, reset, setZoom };
}
